var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m44.51 26.64-1.51-.91v-10.23c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v5.43l-10.49-6.29c-.32-.19-.71-.19-1.03 0l-20 12c-.29.18-.48.51-.48.86v5c0 .36.19.69.51.87.15.09.32.13.49.13.18 0 .36-.05.51-.14l19.49-11.69 19.48 11.69c.3.18.7.19 1.01.01.32-.18.51-.51.51-.87v-5c0-.35-.19-.68-.49-.86zm-7.51-10.14h4v1h-4zm0 3h4v5.03l-4-2.4zm6 11.23-18.49-11.09c-.16-.09-.33-.14-.51-.14s-.36.05-.51.14l-18.49 11.09v-2.67l19-11.4 19 11.4z",
    fill: "#004c3f",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/roof.1f9ca3863ef2dab4a041caebafc2e0d6.svg";
export { ForwardRef as ReactComponent };